/**
 * Composable for debounce functionality
 * Extracted from useBookingForm for reusability
 */

export function useDebounce() {
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	return {
		debounce,
	};
}